import metamorphClient from './metamorphClient'
import fifthaveClient from './fifthaveClient'
import bxlUtils from 'bxl-utils'

function createAttribute(item: any) {
  return metamorphClient.post('/api/v1/_internal/attr', item)
}

function updateAttribute(id: string, update: any) {
  return metamorphClient.put(`/api/v1/_internal/attr/${id}`, update)
}

function getAttributeById(id: string) {
  return metamorphClient.get(`/api/v1/_internal/attr/${id}`)
}

function findAttributeItemOrValues(f: number, t: number, name?: string, type?: number) {
  return metamorphClient.get('/api/v1/_internal/attr', {
    params: {
      f,
      t,
      name: name,
      type: type,
    }
  })
}

function findAttributeItems(f: number, t: number, name?: string) {
  return metamorphClient.get('/api/v1/_internal/attr', {
    params: {
      f,
      t,
      name: name,
      type: 1,
    }
  })
}

function findAttributes(itemId: string, f: number, t: number) {
  return metamorphClient.get(`/api/v1/_internal/attr/${itemId}/values`, {
    params: {
      f,
      t,
    }
  })
}

function searchAttriutes(ids: string[]) {
  return metamorphClient.get(`/api/v1/_internal/attr/_batch`, {
    params: {
      id: ids,
    },
    paramsSerializer: params => {
      return bxlUtils.uri.stringify(params)
    }
  })
}

function deleteAttribute(id: string) {
  return metamorphClient.delete(`/api/v1/_internal/attr/${id}`)
}

function createOrUpdateCatgoryAttribute(category_id: string, body: any) {
  return metamorphClient.post(`/api/v1/_internal/category_attr/${category_id}`, body)
}

function getCategoryAttributeById(id: string) {
  return metamorphClient.get(`/api/v1/_internal/category_attr/${id}`)
}

function findCategoryAttributesByIds(ids?: string[]) {
  return metamorphClient.get(`/api/v1/_internal/category_attr/list`, {
    params: {
      id: ids,
    },
    paramsSerializer: params => {
      return bxlUtils.uri.stringify(params)
    }
  })
}

function findCategoryAttributes(f: number, t: number, ids?: string[], name?: string, value?: string) {
  return metamorphClient.get(`/api/v1/_internal/category_attr/list`, {
    params: {
      f: f,
      t: t,
      id: ids,
      name: name,
      value: value,
    },
    paramsSerializer: params => {
      return bxlUtils.uri.stringify(params)
  }
  })
}

function deleteCategoryAttribute(id: string) {
  return metamorphClient.delete(`/api/v1/_internal/category_attr/${id}`)
}

function unBindCategoryAttributes(items) {
  return metamorphClient.post(`/api/v1/_internal/category_attr/_batch/delete`, {
    items,
  })
}

const FEATURE_IDS_KEY = 'pin_feature_ids'
const ORIGINAL_FEATURE_IDS_KEY = 'feature_ids'

function updateProductAttributeValues(productId: string, featureIds: string[]) {
  return fifthaveClient.post(`api/v1/products/${productId}/attributes`, {
    attributes: {
      [FEATURE_IDS_KEY]: {
        choices: featureIds,
      },
      [ORIGINAL_FEATURE_IDS_KEY]: {
        choices: featureIds,
      },
    }
  })
}

function submitUploadAttributeFile(formData, onUploadProgress?: (total, loaded) => void) {
  return metamorphClient.post(`/api/v1/_internal/prod_attr/task/submit`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress: ({ total, loaded }) => {
      onUploadProgress && onUploadProgress(total, loaded)
    },
  })
}

function getAllImportTasks() {
  return metamorphClient.get(`/api/v1/_internal/prod_attr/tasks`)
}

function getImportTasksById(id: string, f: number , to: number) {
  return metamorphClient.get(`/api/v1/_internal/prod_attr/task/${id}`, {
    params: { f, t: to }
  })
}

export {
  createAttribute,
  updateAttribute,
  getAttributeById,
  findAttributes,
  findAttributeItems,
  findAttributeItemOrValues,
  searchAttriutes,
  deleteAttribute,
  createOrUpdateCatgoryAttribute,
  deleteCategoryAttribute,
  unBindCategoryAttributes,
  getCategoryAttributeById,
  findCategoryAttributes,
  findCategoryAttributesByIds,
  updateProductAttributeValues,
  FEATURE_IDS_KEY,
  ORIGINAL_FEATURE_IDS_KEY,
  getAllImportTasks,
  getImportTasksById,
  submitUploadAttributeFile,
}
